var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-accordion',{attrs:{"title":_vm.$t('fontEdit'),"opened":_vm.isOpen}},[_c('om-font',{attrs:{"propsProperty":_vm.propsProperty,"subPath":_vm.subPath,"typeOfComponent":_vm.typeOfComponent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }